import { Ruleset } from 'entities/campaign';
import { EntityWithId } from 'services/apiGatewayClient/interface';
import { MpsMessageRulesetResponse } from '../types';
import { normalizeMpsAudit } from './normalizeMpsAudit';

/**
 * Maps MPS message ruleset API response (Go flat) to app entity.
 * Caller should apply fromStorageFormat to entity.channels if needed.
 */
export function mapMpsMessageRulesetResponseToEntity(item: MpsMessageRulesetResponse): EntityWithId<Ruleset> {
  const eventTriggers = Array.isArray(item.eventTriggers) ? item.eventTriggers : [];
  const channels = Array.isArray(item.channels) ? (item.channels as Ruleset['channels']) : [];
  const rules = Array.isArray(item.rules) ? (item.rules as Ruleset['rules']) : [];

  return {
    id: item.id,
    entity: {
      campaignId: item.campaignId,
      name: item.name,
      subFeature: item.subFeature as Ruleset['subFeature'],
      eventTriggers: eventTriggers as Ruleset['eventTriggers'],
      channels,
      rules,
      audit: normalizeMpsAudit(item.audit),
    },
  };
}
